export default __webpack_public_path__ + "static/media/loading.fc13b9ff.svg";